import { IModelDataV1, Model } from '@df/catalog/model';
export interface ISeeRangeInStoreData extends IModelDataV1 {
    product: number;
    storepickup: number;
    nyw_item_range_code_nh?: number;
}
export class SeeRangeInStore extends Model<ISeeRangeInStoreData, string> {
    static override type = 'seeRangeInStore';
    override maxVerbosity = 1;
    get productId(): number | undefined {
        return this.data?.product;
        // if (this.data?.product) {
        //     return parseInt(this.data.product, 10);
        // }
        // return undefined;
    }
    get storepickupId(): number | undefined {
        return this.data?.storepickup;
        // if (this.data?.storepickup) {
        //     return parseInt(this.data.storepickup, 10);
        // }
        // return undefined;
    }
    protected override set(data: ISeeRangeInStoreData, verbosity: number): void {
        super.set(data, 1);
    }
}
